import { Box, LargeText, Text } from "@shared/primitive-components"
import { rebatesStyles as styles } from "../styles"

export type StatProps = {
  disabled?: boolean
  lowercaseLabel?: boolean
  stat: string
  statLabel?: string
  dataTestIds?: {
    stat?: string
    label?: string
  }
}

export const Stat = ({ stat, statLabel, lowercaseLabel, disabled, dataTestIds }: StatProps) => (
  <Box>
    <LargeText tag="span" css={styles.rebateStat(disabled)} data-testid={dataTestIds?.stat}>
      {stat}
    </LargeText>
    {statLabel && (
      <Text tag="span" css={styles.rebateStatUnit(lowercaseLabel)} data-testid={dataTestIds?.label}>
        {statLabel}
      </Text>
    )}
  </Box>
)

Stat.defaultProps = {
  dataTestIds: undefined,
  disabled: undefined,
  lowercaseLabel: undefined,
  statLabel: undefined,
}
